export class TripCreationTimeoutError extends Error {
  static readonly defaultUserMessage =
    "Trip creation is taking longer than expected. It may still complete in the background—please check it in 'My Trips'.";

  constructor(message: string = TripCreationTimeoutError.defaultUserMessage) {
    super(message);
    this.name = 'TripCreationTimeoutError';
  }
}

